import { type ActivatedRouteSnapshot } from '@angular/router';

import { type MyreRoute } from '../interfaces';

export function getAbsolutePathForRoute(
  route: MyreRoute,
  baseUrl: string,
): string {
  const segments = [baseUrl, route.path];

  let absolutePath = '';

  for (const segment of segments) {
    if (segment) {
      absolutePath += `/${segment}`;
    }
  }

  return absolutePath;
}

export function getPreviousRouteForCurrentRoute(
  route: ActivatedRouteSnapshot,
  navigationHistory: ActivatedRouteSnapshot[],
): ActivatedRouteSnapshot {
  let currentRoute = route?.parent;

  const navigationHistoryWithoutCurrentRoute = navigationHistory.slice(0, -1);

  // If user has navigated back, return the last route in the history, else, return the default previous route based on routing configuration
  if (navigationHistoryWithoutCurrentRoute?.length) {
    return navigationHistoryWithoutCurrentRoute.at(-1);
  }

  if (!currentRoute) {
    return null;
  }

  while (currentRoute) {
    const currentMenu = currentRoute.data?.menu;

    if (currentMenu && route.data?.menu !== currentMenu) {
      return currentRoute;
    }

    // TODO CHECK THIS
    if (
      !currentRoute.parent &&
      getAbsolutePathForRoute(route.parent, '') ===
        getAbsolutePathForRoute(currentRoute, '')
    ) {
      return null;
    }

    currentRoute = currentRoute.parent;
  }

  return route;
}

export function getBaseUrlFromActivatedRoute(
  route: ActivatedRouteSnapshot,
): string {
  const segments: string[] = [];

  while (route) {
    segments.unshift(...route.url.map(segment => segment.path));
    route = route.parent;
  }

  return segments.join('/');
}

export function areBrothers(
  route1: ActivatedRouteSnapshot,
  route2: ActivatedRouteSnapshot,
): boolean {
  return (
    getBaseUrlFromActivatedRoute(route1).split('/').length ===
    getBaseUrlFromActivatedRoute(route2).split('/').length
  );
}
